import React, { useState } from 'react'
import MainChat from '../../Components/Chat/Main/Main'


function Chat() {

  return (
    

        
        <MainChat />
      
  )
}

export default Chat